import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaperplaneRound = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 190 190",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M95.036 159.768C130.687 159.768 159.588 130.867 159.588 95.216C159.588 59.5649 130.687 30.6641 95.036 30.6641C59.385 30.6641 30.4841 59.5649 30.4841 95.216C30.4841 130.867 59.385 159.768 95.036 159.768Z",
			fill: "#1BA290"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M95 175.569C139.497 175.569 175.57 139.497 175.57 94.9993C175.57 50.5019 139.497 14.4297 95 14.4297C50.5027 14.4297 14.4304 50.5019 14.4304 94.9993C14.4304 139.497 50.5027 175.569 95 175.569Z",
			fill: "#1BA290"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M95 190C147.467 190 190 147.467 190 95C190 42.533 147.467 0 95 0C42.533 0 0 42.533 0 95C0 147.467 42.533 190 95 190Z",
			fill: "#1BA290"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.2865 117.891L55.8032 137.806L57.8777 121.703L63.5773 112.719L80.2865 117.891Z",
			fill: "#155149"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.221 133.12L25.3077 97.2981C24.4489 96.8928 24.5855 95.631 25.5112 95.4189L172.311 61.7923C173.295 61.567 173.955 62.7751 173.234 63.4814L102.348 132.93C102.049 133.223 101.599 133.298 101.221 133.12Z",
			fill: "#1BA290"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.7795 110.654L55.8033 137.805L67.3496 117.046L171.662 63.3785L53.7795 110.654Z",
			fill: "#188475"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.9327 108.568C54.8713 108.412 66.3954 103.734 80.6617 98.1149C94.9375 92.4916 106.549 88.0634 106.608 88.2133C106.669 88.3692 95.1452 93.047 80.8789 98.6665C66.6127 104.286 54.9917 108.718 54.9327 108.568Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.202 84.4582C149.088 84.3356 151.219 82.172 153.955 79.6207C156.692 77.0677 159.002 75.099 159.112 75.2168C159.226 75.3393 157.095 77.5029 154.359 80.0543C151.623 82.6056 149.312 84.576 149.202 84.4582Z",
			fill: "#FAFAFA"
		})
	]
});
export default SvgPaperplaneRound;
